<template>
    <div class="w-full">
        <h2 class=" mb-16 text-[16px] underline">Revue du semestre</h2>

        <div class="flex items-center gap-x-5 px-10">
            <div v-bind:class="getActiveClass(1)" class="size-10 rounded-full border-2 border-[#3c41e9] cursor-pointer flex items-center justify-center">
                1
            </div>

            <div class="grow h-2 rounded-lg bg-[#3c41e9]"></div>
            
            <div v-bind:class="getActiveClass(2)" class="size-10 rounded-full border-2 border-[#3c41e9] cursor-pointer text-[#3c41e9] flex items-center justify-center">
                2
            </div>

            <div class="grow h-2 rounded-lg bg-[#3c41e9]"></div>

            <div v-bind:class="getActiveClass(3)" class="size-10 rounded-full border-2 border-[#3c41e9] cursor-pointer text-[#3c41e9] flex items-center justify-center">
                3
            </div>

            <div class="grow h-2 rounded-lg bg-[#3c41e9]"></div>

            <div v-bind:class="getActiveClass(4)" class="size-10 rounded-full border-2 border-[#3c41e9] cursor-pointer text-[#3c41e9] flex items-center justify-center">
                4
            </div>
        </div>

        <div class="w-full min-h-[560px]">
        
            <div v-if="getActiveTab(1)" class="w-full min-h-[560px] flex items-center justify-center p-8">
                <p class="text-center text-[18px] font-light">En attente de validation <br> ressource humaine</p>
            </div>

            <div v-if="getActiveTab(2)" class="w-full min-h-[560px] p-8">
                <h2 class="text-center text-[16px] font-light">Veuillez remplir le formulaire</h2>
                <form @submit.prevent="submitColabReview" class="w-full mt-4 flex flex-col gap-y-8">
                    <div class="flex flex-col gap-y-1">
                        <label for="contribution" class="font-extralight text-[16px]">Contribution <span class="text-[#ff0e0e]">*</span></label>
                        <textarea v-model="form_user.contributions" name="contribution" id="contribution" placeholder="Contribution" class="min-h-[150px] border rounded-lg p-3"></textarea>
                    </div>

                    <div class="flex flex-col gap-y-1">
                        <label for="contribution" class="font-extralight text-[16px]">Contribution succès externe <span class="text-[#ff0e0e]">*</span></label>
                        <textarea v-model="form_user.contributions_externe" name="contribution" id="contribution" placeholder="Contribution succès externe" class="min-h-[150px] border rounded-lg p-3"></textarea>
                    </div>

                    <div class="flex flex-col gap-y-1">
                        <label for="contribution" class="font-extralight text-[16px]">Apport externe <span class="text-[#ff0e0e]">*</span></label>
                        <textarea v-model="form_user.apport_externe" name="contribution" id="contribution" placeholder="Apport externe" class="min-h-[150px] border rounded-lg p-3"></textarea>
                    </div>

                    <div class="flex flex-col gap-y-1">
                        <label for="contribution" class="font-extralight text-[16px]">Point à améliorer <span class="text-[#ff0e0e]">*</span></label>
                        <textarea v-model="form_user.ameliorations" name="contribution" id="contribution" placeholder="Point à améliorer" class="min-h-[150px] border rounded-lg p-3"></textarea>
                    </div>

                    <button type="submit" class="text-white bg-[#3c41e9] rounded-lg h-[40px] w-full flex items-center justify-center ">
                            <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                            <span v-if="!asSend">Enregistrer</span>
                    </button>
                </form>
            </div>

            <div v-if="getActiveTab(3)" class="w-full min-h-[560px] p-8">
                <h2 class="text-center text-[16px] font-light">Veuillez remplir le formulaire</h2>
                <form @submit.prevent="submitSupReview" class="w-full mt-4 flex flex-col gap-y-8">

                    <div class="flex flex-col gap-y-1">
                        <label for="superieur" class="font-extralight text-[16px]">Note du supérieur <span class="text-[red]">*</span></label>
                        <input type="number" name="superieur" min="0" max="5" v-model="form_sup.mark" placeholder="Note" class="h-[40px] border rounded-lg p-3">
                    </div>

                    <div class="flex flex-col gap-y-1">
                        <label for="commentaire" class="font-extralight text-[16px]">Commentaire<span class="text-[#ff0e0e]">*</span></label>
                        <textarea v-model="form_sup.sup_comment" name="commentaire" id="commentaire" placeholder="Commentaire" class="min-h-[150px] border rounded-lg p-3"></textarea>
                    </div>

                    <button type="submit" class="text-white bg-[#3c41e9] rounded-lg h-[40px] w-full flex items-center justify-center ">
                            <Loader2 v-if="asSend2" class="animate-spin mx-auto"/>
                            <span v-if="!asSend2">Enregistrer</span>
                    </button>
                </form>
            </div>

            <div v-if="getActiveTab(4)" class="w-full min-h-[560px] p-8">
                <div class="h-[250px] w-full flex items-center justify-center">
                    <p class="text-center text-[15px] font-light">En attente de <br>réponse superviseur </p>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import API from '@/service/API';
import {
    Loader2
} from "lucide-vue-next";
import toast from '@/components/ui/toast';
export default {
    name : "ReviewView",
    components:{Loader2},
    props:[],
    data(){
        return {
            step: 2,
            asSend:false,
            isColab:true,
            asSend2:false,
            reviews:[],
            selectedReview:"",
            form_user:{
                contributions:"",
                contributions_externe:"",
                apport_externe:"",
                ameliorations:"",
            },
            form_sup:{
                mark:"",
                sup_comment:"",
            }
        }
    },
    mounted(){
        this.getAllReviewSession();
    },
    methods:{
        selectStep(step){
            this.step = step;
        },
        getActiveTab(step){
            return this.step == step;
        },
        getActiveClass(step){
            return step <= this.step ? "bg-[#3c41e9] text-white" : "";
        },
        clearForm(){
            this.form_user = {
                contributions:"",
                contributions_externe:"",
                apport_externe:"",
                ameliorations:"",
            }
            this.form_sup = {
                mark:"",
                sup_comment:"",
            }
        },
        getAllReviewSession(){
            API.get('/sessions')
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.reviews = data.data["data"];
                    const length = data.data["data"].length;
                    this.selectedReview = data.data["data"][length - 1].id;
                    // this.displayLogic(data.data["data"]);
                }else{
                    toast.error("Oops..",data.data["message"],4000)
                }
            })
            .catch(()=>{
                toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
            })
        },
        submitColabReview(){
            this.asSend = true;
            API.post("/updates", {
                ...this.form_user,
                type: "MID TERM REVIEW",
                session_id: this.selectedReview,
                user_id: localStorage.getItem("userId")
            })
            .then((response) => {
                    if(response.data["status"]){
                        toast.success("Succès","Enregistrer",3000);
                        this.getAllReviewSession();
                        this.clearForm();
                    }else{
                        toast.error("Erreur lors de la mise à jour de l'objectif");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Erreur lors de la mise à jour de l'objectif");
                })
                .finally(() => {
                    this.asSend = false;
                });
        },
        submitSupReview(){
            this.asSend2 = true;
            API.put("/updates/10", {
                ...this.form_sup,
                sup_id: localStorage.getItem("userId")
            }).then((response) => {
                    if(response.data["status"]){
                        toast.success("Succès","Enregistrer",3000);
                        this.clearForm();
                    }else{
                        toast.error("Erreur lors de la mise à jour de l'objectif");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Erreur lors de la mise à jour de l'objectif");
                })
                .finally(() => {
                    this.asSend2 = false;
                });
        },
        displayLogic(tab){
            const length = tab.length;
            if(length == 0){
                this.step = 1;
            }else if(!tab[length - 1].reviews[0]?.contributions){
                this.step = 2;
            }else if(!tab[length - 1].reviews[0]?.mark && !this.isColab){
                this.step = 3;
            }else{
                this.step = 4;
            }
        }
    }
}
</script>